import React from "react";

const CookiesPolicy = () => {
  return <section className="py-5 fw-semibold">Cookies Policy...</section>;
};

export default CookiesPolicy;
